import React from 'react';

export default function Services() {
  return (
    <section id="price" className='py-10 md:py-16  gradient-background' style={{ backgroundImage: `url("/prices.svg")`, backgroundRepeat: "no-repeat",backgroundPosition: "bottom" }}>
          
      <div className='container' >
        

        <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 lg:gap-8 xl:gap-10'>
        <a href="https://gpu.flopscloud.cn" >
          <div className="card bg-base-200 transform-gpu transition-all duration-300  opacity-80 hover:-translate-y-2 hover:shadow-lg">
            <div className="card-body items-center text-center gap-4">
              {/* <i className='bi bi-search text-4xl'></i> */}
              <h2 className="card-title">NVIDIA RTX 4090 / 24GB</h2>
              <p>
                单精 82.58 TFLOPS <br /> 半精 165.2 Tensor TFLOPS                <br />
                  <span className='text-2xl font-bold'>￥1.98</span>  /时<span className='text-sm font-bold' style={{color: '#fff',backgroundColor: '#f00',padding: '5px',borderRadius: '15px'}}>会员95折</span>
              </p>
            </div>
          </div>
          </a>


          <a href="https://gpu.flopscloud.cn" >
          <div className="card bg-base-200 transform-gpu transition-all duration-300 opacity-80 hover:-translate-y-2 hover:shadow-lg">
            <div className="card-body items-center text-center gap-4">
              {/* <i className='bi bi-window-stack text-4xl'></i> */}

              

              <h2 className="card-title">NVIDIA RTX 2080Ti / 22GB</h2>
              <p>
              单精 13.45 TFLOPS <br /> 半精 53.8 Tensor TFLOPS               <br />
                  <span className='text-2xl font-bold'>￥1.32</span>  /时<span className='text-sm font-bold' style={{color: '#fff',backgroundColor: '#f00',padding: '5px',borderRadius: '15px'}}>会员95折</span>
              </p>
            </div>
          </div>
          </a>

          <a href="https://gpu.flopscloud.cn" >
          <div className="card bg-base-200 transform-gpu transition-all duration-300 opacity-80 hover:-translate-y-2 hover:shadow-lg">
            <div className="card-body items-center text-center gap-4">
              {/* <i className='bi bi-badge-ad text-4xl'></i> */}
              <h2 className="card-title">NVIDIA A100 SXM4 / 80GB</h2>
              <p>单精 19.5 TFLOPS  <br /> 半精 312 Tensor TFLOPS  <br />
                  <span className='text-2xl font-bold'>￥6.68</span>  /时  <span className='text-sm font-bold' style={{color: '#fff',backgroundColor: '#f00',padding: '5px',borderRadius: '15px'}}>会员9折</span>
              </p>
            </div>
          </div>
          </a>
          
        </div>
      </div>
    </section>
  )
}